// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesCtf = {
  ctfAuth: "CTF 认证",
  ctfDependency: "CTF 依赖",
  ctfRuntime: "CTF 运行时",
  ctfBusinessEvent: "CTF 业务事件",
} as const;
